import { FC, useEffect, useMemo, useState } from 'react';

import { parseCookies } from 'nookies';

import { useModal } from '~/shared/hooks/modal';
import { cookies } from '~/shared/constants/cookies';

import { PraNotasCertificatesAlertModal } from '../PraNotasCertificatesAlertModal';
import { usePraNotasCertificatesAlerts } from '../../hooks/praNotasCertificatesAlerts';

const PRA_NOTAS_ALERT_SESSION_KEY = 'pra_notas_certificates_alert_seen';

export const PraNotasCertificatesAlertManager: FC = () => {
  const { openModal } = useModal();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { alerts, hasAlerts, isLoading, hasExpired, highestSeverity } =
    usePraNotasCertificatesAlerts();
  const authToken = parseCookies()[cookies.AUTH_TOKEN];

  const sessionAlertKey = useMemo(
    () => (authToken ? `${PRA_NOTAS_ALERT_SESSION_KEY}:${authToken}` : null),
    [authToken]
  );

  useEffect(() => {
    if (
      typeof window === 'undefined' ||
      isLoading ||
      !hasAlerts ||
      isModalOpen ||
      !sessionAlertKey ||
      window.sessionStorage.getItem(sessionAlertKey)
    ) {
      return;
    }

    window.sessionStorage.setItem(sessionAlertKey, 'true');

    openModal(PraNotasCertificatesAlertModal, {
      modalProps: {
        size: 'big',
        showHeader: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
        contentStyle: {
          padding: 0,
        },
      },
      onClose: () => {
        setIsModalOpen(false);
      },
      props: {
        alerts,
        highestSeverity: highestSeverity === 'none' ? 'info' : highestSeverity,
        hasExpired,
        onDismiss: () => {
          setIsModalOpen(false);
        },
      },
    });

    // eslint-disable-next-line react-hooks/set-state-in-effect -- Show the certificate alert once per browser session, synchronizing modal context with sessionStorage after commit.
    setIsModalOpen(true);
  }, [
    alerts,
    hasAlerts,
    hasExpired,
    highestSeverity,
    isLoading,
    isModalOpen,
    openModal,
    sessionAlertKey,
  ]);

  return null;
};
